@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package materialextension.multiplatform_material_extension.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.StringResource

private object CommonMainString0 {
  public val mel_April: StringResource by 
      lazy { init_mel_April() }

  public val mel_August: StringResource by 
      lazy { init_mel_August() }

  public val mel_December: StringResource by 
      lazy { init_mel_December() }

  public val mel_February: StringResource by 
      lazy { init_mel_February() }

  public val mel_January: StringResource by 
      lazy { init_mel_January() }

  public val mel_July: StringResource by 
      lazy { init_mel_July() }

  public val mel_June: StringResource by 
      lazy { init_mel_June() }

  public val mel_March: StringResource by 
      lazy { init_mel_March() }

  public val mel_May: StringResource by 
      lazy { init_mel_May() }

  public val mel_November: StringResource by 
      lazy { init_mel_November() }

  public val mel_October: StringResource by 
      lazy { init_mel_October() }

  public val mel_September: StringResource by 
      lazy { init_mel_September() }

  public val mel_cancel: StringResource by 
      lazy { init_mel_cancel() }

  public val mel_clear: StringResource by 
      lazy { init_mel_clear() }

  public val mel_friday_short: StringResource by 
      lazy { init_mel_friday_short() }

  public val mel_monday_short: StringResource by 
      lazy { init_mel_monday_short() }

  public val mel_saturday_short: StringResource by 
      lazy { init_mel_saturday_short() }

  public val mel_select: StringResource by 
      lazy { init_mel_select() }

  public val mel_select_date: StringResource by 
      lazy { init_mel_select_date() }

  public val mel_select_date_period: StringResource by 
      lazy { init_mel_select_date_period() }

  public val mel_select_month: StringResource by 
      lazy { init_mel_select_month() }

  public val mel_select_year: StringResource by 
      lazy { init_mel_select_year() }

  public val mel_sunday_short: StringResource by 
      lazy { init_mel_sunday_short() }

  public val mel_thursday_short: StringResource by 
      lazy { init_mel_thursday_short() }

  public val mel_tuesday_short: StringResource by 
      lazy { init_mel_tuesday_short() }

  public val mel_wednesday_short: StringResource by 
      lazy { init_mel_wednesday_short() }
}

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("mel_April", CommonMainString0.mel_April)
  map.put("mel_August", CommonMainString0.mel_August)
  map.put("mel_December", CommonMainString0.mel_December)
  map.put("mel_February", CommonMainString0.mel_February)
  map.put("mel_January", CommonMainString0.mel_January)
  map.put("mel_July", CommonMainString0.mel_July)
  map.put("mel_June", CommonMainString0.mel_June)
  map.put("mel_March", CommonMainString0.mel_March)
  map.put("mel_May", CommonMainString0.mel_May)
  map.put("mel_November", CommonMainString0.mel_November)
  map.put("mel_October", CommonMainString0.mel_October)
  map.put("mel_September", CommonMainString0.mel_September)
  map.put("mel_cancel", CommonMainString0.mel_cancel)
  map.put("mel_clear", CommonMainString0.mel_clear)
  map.put("mel_friday_short", CommonMainString0.mel_friday_short)
  map.put("mel_monday_short", CommonMainString0.mel_monday_short)
  map.put("mel_saturday_short", CommonMainString0.mel_saturday_short)
  map.put("mel_select", CommonMainString0.mel_select)
  map.put("mel_select_date", CommonMainString0.mel_select_date)
  map.put("mel_select_date_period", CommonMainString0.mel_select_date_period)
  map.put("mel_select_month", CommonMainString0.mel_select_month)
  map.put("mel_select_year", CommonMainString0.mel_select_year)
  map.put("mel_sunday_short", CommonMainString0.mel_sunday_short)
  map.put("mel_thursday_short", CommonMainString0.mel_thursday_short)
  map.put("mel_tuesday_short", CommonMainString0.mel_tuesday_short)
  map.put("mel_wednesday_short", CommonMainString0.mel_wednesday_short)
}

internal val Res.string.mel_April: StringResource
  get() = CommonMainString0.mel_April

private fun init_mel_April(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_April", "mel_April",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    10, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    10, 25),
    )
)

internal val Res.string.mel_August: StringResource
  get() = CommonMainString0.mel_August

private fun init_mel_August(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_August", "mel_August",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    44, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    36, 26),
    )
)

internal val Res.string.mel_December: StringResource
  get() = CommonMainString0.mel_December

private fun init_mel_December(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_December", "mel_December",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    79, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    63, 32),
    )
)

internal val Res.string.mel_February: StringResource
  get() = CommonMainString0.mel_February

private fun init_mel_February(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_February", "mel_February",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    120, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    96, 32),
    )
)

internal val Res.string.mel_January: StringResource
  get() = CommonMainString0.mel_January

private fun init_mel_January(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_January", "mel_January",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    161, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    129, 31),
    )
)

internal val Res.string.mel_July: StringResource
  get() = CommonMainString0.mel_July

private fun init_mel_July(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_July", "mel_July",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    197, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    161, 24),
    )
)

internal val Res.string.mel_June: StringResource
  get() = CommonMainString0.mel_June

private fun init_mel_June(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_June", "mel_June",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    226, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    186, 24),
    )
)

internal val Res.string.mel_March: StringResource
  get() = CommonMainString0.mel_March

private fun init_mel_March(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_March", "mel_March",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    255, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    211, 25),
    )
)

internal val Res.string.mel_May: StringResource
  get() = CommonMainString0.mel_May

private fun init_mel_May(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_May", "mel_May",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    285, 23),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    237, 19),
    )
)

internal val Res.string.mel_November: StringResource
  get() = CommonMainString0.mel_November

private fun init_mel_November(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_November", "mel_November",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    309, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    257, 32),
    )
)

internal val Res.string.mel_October: StringResource
  get() = CommonMainString0.mel_October

private fun init_mel_October(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_October", "mel_October",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    346, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    290, 31),
    )
)

internal val Res.string.mel_September: StringResource
  get() = CommonMainString0.mel_September

private fun init_mel_September(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_September", "mel_September",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    386, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    322, 33),
    )
)

internal val Res.string.mel_cancel: StringResource
  get() = CommonMainString0.mel_cancel

private fun init_mel_cancel(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_cancel", "mel_cancel",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    432, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    356, 26),
    )
)

internal val Res.string.mel_clear: StringResource
  get() = CommonMainString0.mel_clear

private fun init_mel_clear(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_clear", "mel_clear",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    467, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    383, 25),
    )
)

internal val Res.string.mel_friday_short: StringResource
  get() = CommonMainString0.mel_friday_short

private fun init_mel_friday_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:mel_friday_short", "mel_friday_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    509, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    409, 28),
    )
)

internal val Res.string.mel_monday_short: StringResource
  get() = CommonMainString0.mel_monday_short

private fun init_mel_monday_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:mel_monday_short", "mel_monday_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    542, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    438, 28),
    )
)

internal val Res.string.mel_saturday_short: StringResource
  get() = CommonMainString0.mel_saturday_short

private fun init_mel_saturday_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:mel_saturday_short", "mel_saturday_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    575, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    467, 30),
    )
)

internal val Res.string.mel_select: StringResource
  get() = CommonMainString0.mel_select

private fun init_mel_select(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_select", "mel_select",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    874, 38),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    678, 26),
    )
)

internal val Res.string.mel_select_date: StringResource
  get() = CommonMainString0.mel_select_date

private fun init_mel_select_date(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_select_date", "mel_select_date",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    697, 59),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    557, 39),
    )
)

internal val Res.string.mel_select_date_period: StringResource
  get() = CommonMainString0.mel_select_date_period

private fun init_mel_select_date_period(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:mel_select_date_period", "mel_select_date_period",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    610, 86),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    498, 58),
    )
)

internal val Res.string.mel_select_month: StringResource
  get() = CommonMainString0.mel_select_month

private fun init_mel_select_month(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:mel_select_month", "mel_select_month",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    757, 60),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    597, 40),
    )
)

internal val Res.string.mel_select_year: StringResource
  get() = CommonMainString0.mel_select_year

private fun init_mel_select_year(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mel_select_year", "mel_select_year",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    818, 55),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    638, 39),
    )
)

internal val Res.string.mel_sunday_short: StringResource
  get() = CommonMainString0.mel_sunday_short

private fun init_mel_sunday_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:mel_sunday_short", "mel_sunday_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    913, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    705, 28),
    )
)

internal val Res.string.mel_thursday_short: StringResource
  get() = CommonMainString0.mel_thursday_short

private fun init_mel_thursday_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:mel_thursday_short", "mel_thursday_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    946, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    734, 30),
    )
)

internal val Res.string.mel_tuesday_short: StringResource
  get() = CommonMainString0.mel_tuesday_short

private fun init_mel_tuesday_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:mel_tuesday_short", "mel_tuesday_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    981, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    765, 29),
    )
)

internal val Res.string.mel_wednesday_short: StringResource
  get() = CommonMainString0.mel_wednesday_short

private fun init_mel_wednesday_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:mel_wednesday_short", "mel_wednesday_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    org.jetbrains.compose.resources.RegionQualifier("RU"), ),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values-ru-rRU/strings.commonMain.cvr",
    1015, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/values/strings.commonMain.cvr",
    795, 31),
    )
)
